const css = `.veXmXW__noselect{-webkit-touch-callout:none;user-select:none}.veXmXW__rotated{transform:rotate(90deg)}.veXmXW__boundaryBox{cursor:unset;pointer-events:none;position:absolute;inset:0}.veXmXW__boundaryBox.veXmXW__dragging{cursor:grabbing;pointer-events:all}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"boundaryBox":"veXmXW__boundaryBox","dragging":"veXmXW__dragging","noselect":"veXmXW__noselect","rotated":"veXmXW__rotated"};
